const FacebookVideos1 = [
  // {
  //   title: "Stay Awhile (BOTB)", 
  //   src: "https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2Ftheguestsjazz%2Fvideos%2F715472208849492%2F&show_text=0&mute=0",
  //   vertical: false
  // },
  {
    title: "Hold On Tight (BOTB)", 
    src: "https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2Ftheguestsjazz%2Fvideos%2F2047255312240550%2F&show_text=0&mute=0",
    vertical: false
  },
  {
    title: "Stevie Wonder (BOTB)", 
    src: "https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2Ftheguestsjazz%2Fvideos%2F384510632338518%2F&show_text=0&mute=0",
    vertical: false
  }  
]
const FacebookVideos2 = [
  {
    title: "Avenue L (Mocktail Party)", 
    src: "https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2Ftheguestsjazz%2Fvideos%2F353903118670587%2F&show_text=0&mute=0",
    vertical: true
  },
  {
    title: "I Feel Good (Prom)", 
    src: "https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2Ftheguestsjazz%2Fvideos%2F305809510314908%2F&show_text=0&mute=0",
    vertical: true
  },
  {
    title: "Gold Beat (Mocktail Party)", 
    src: "https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2Ftheguestsjazz%2Fvideos%2F376686159839194%2F&show_text=0&mute=0",
    vertical: true
  },
]
const FacebookVideos3 = [
  {
    title: "Isn't She Lovely", 
    src: "https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2Ftheguestsjazz%2Fvideos%2F434745930621342%2F&show_text=0&mute=0",
    vertical: false
  },
  {
    title: "If I Ain't Got You", 
    src: "https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2Ftheguestsjazz%2Fvideos%2F1706089592844695%2F&show_text=0&mute=0",
    vertical: false
  },
]


export { 
  FacebookVideos1,
  FacebookVideos2,
  FacebookVideos3
}